// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file driver_incident.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FileUpload, FileUploadJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { DateTimeFilter, DateTimeFilterJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file driver_incident.proto.
 */
export const file_driver_incident: GenFile = /*@__PURE__*/
  fileDesc("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", [file_file_upload, file_general, file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.DriverIncident
 */
export type DriverIncident = Message<"raccoonai.DriverIncident"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * The driver, shift and truck: always set on a driver's report, set on a
   * dispatcher's when the shift is known, unset on the system's.
   *
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 4 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Set when the driver was on an accepted route at the moment of reporting.
   *
   * @generated from field: optional uint64 route_id = 6 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * Set for incidents reported on a job (the driver's current job).
   *
   * @generated from field: optional uint64 job_id = 7 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required raccoonai.DriverIncidentType type = 8;
   */
  type: DriverIncidentType;

  /**
   * @generated from field: repeated raccoonai.FileUpload files = 9;
   */
  files: FileUpload[];

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 10 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * Who recorded it: the driver or a dispatcher; unset for the system.
   *
   * @generated from field: optional uint64 author_id = 11 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * Free text, e.g. a dispatcher's explanation (required for OTHER).
   *
   * @generated from field: optional string explanation = 12;
   */
  explanation: string;
};

/**
 * @generated from message raccoonai.DriverIncident
 */
export type DriverIncidentJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * The driver, shift and truck: always set on a driver's report, set on a
   * dispatcher's when the shift is known, unset on the system's.
   *
   * @generated from field: optional uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 4 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Set when the driver was on an accepted route at the moment of reporting.
   *
   * @generated from field: optional uint64 route_id = 6 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * Set for incidents reported on a job (the driver's current job).
   *
   * @generated from field: optional uint64 job_id = 7 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required raccoonai.DriverIncidentType type = 8;
   */
  type?: DriverIncidentTypeJson;

  /**
   * @generated from field: repeated raccoonai.FileUpload files = 9;
   */
  files?: FileUploadJson[];

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 10 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * Who recorded it: the driver or a dispatcher; unset for the system.
   *
   * @generated from field: optional uint64 author_id = 11 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * Free text, e.g. a dispatcher's explanation (required for OTHER).
   *
   * @generated from field: optional string explanation = 12;
   */
  explanation?: string;
};

/**
 * Describes the message raccoonai.DriverIncident.
 * Use `create(DriverIncidentSchema)` to create a new message.
 */
export const DriverIncidentSchema: GenMessage<DriverIncident, {jsonType: DriverIncidentJson}> = /*@__PURE__*/
  messageDesc(file_driver_incident, 0);

/**
 * A dispatcher's incident on a job: why it was not carried out. Recorded as is: the
 * job's status and its retries are left alone, and no post-action runs.
 *
 * @generated from message raccoonai.JobIncidentCreateRequest
 */
export type JobIncidentCreateRequest = Message<"raccoonai.JobIncidentCreateRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * Any type but UNDEFINED.
   *
   * @generated from field: required raccoonai.DriverIncidentType type = 3;
   */
  type: DriverIncidentType;

  /**
   * Required for OTHER; at most 255 characters.
   *
   * @generated from field: optional string explanation = 4;
   */
  explanation: string;
};

/**
 * A dispatcher's incident on a job: why it was not carried out. Recorded as is: the
 * job's status and its retries are left alone, and no post-action runs.
 *
 * @generated from message raccoonai.JobIncidentCreateRequest
 */
export type JobIncidentCreateRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * Any type but UNDEFINED.
   *
   * @generated from field: required raccoonai.DriverIncidentType type = 3;
   */
  type?: DriverIncidentTypeJson;

  /**
   * Required for OTHER; at most 255 characters.
   *
   * @generated from field: optional string explanation = 4;
   */
  explanation?: string;
};

/**
 * Describes the message raccoonai.JobIncidentCreateRequest.
 * Use `create(JobIncidentCreateRequestSchema)` to create a new message.
 */
export const JobIncidentCreateRequestSchema: GenMessage<JobIncidentCreateRequest, {jsonType: JobIncidentCreateRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_incident, 1);

/**
 * @generated from message raccoonai.DriverIncidentListRequest
 */
export type DriverIncidentListRequest = Message<"raccoonai.DriverIncidentListRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetimeFilter?: DateTimeFilter;

  /**
   * @generated from field: optional raccoonai.DriverIncidentType type = 3;
   */
  type: DriverIncidentType;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional uint64 route_id = 6 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * Only the incidents of these jobs.
   *
   * @generated from field: repeated uint64 job_ids = 7 [json_name = "job_ids"];
   */
  jobIds: bigint[];
};

/**
 * @generated from message raccoonai.DriverIncidentListRequest
 */
export type DriverIncidentListRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetime_filter?: DateTimeFilterJson;

  /**
   * @generated from field: optional raccoonai.DriverIncidentType type = 3;
   */
  type?: DriverIncidentTypeJson;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional uint64 route_id = 6 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * Only the incidents of these jobs.
   *
   * @generated from field: repeated uint64 job_ids = 7 [json_name = "job_ids"];
   */
  job_ids?: string[];
};

/**
 * Describes the message raccoonai.DriverIncidentListRequest.
 * Use `create(DriverIncidentListRequestSchema)` to create a new message.
 */
export const DriverIncidentListRequestSchema: GenMessage<DriverIncidentListRequest, {jsonType: DriverIncidentListRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_incident, 2);

/**
 * @generated from message raccoonai.DriverIncidentList
 */
export type DriverIncidentList = Message<"raccoonai.DriverIncidentList"> & {
  /**
   * @generated from field: repeated raccoonai.DriverIncident driver_incidents = 1 [json_name = "driver_incidents"];
   */
  driverIncidents: DriverIncident[];
};

/**
 * @generated from message raccoonai.DriverIncidentList
 */
export type DriverIncidentListJson = {
  /**
   * @generated from field: repeated raccoonai.DriverIncident driver_incidents = 1 [json_name = "driver_incidents"];
   */
  driver_incidents?: DriverIncidentJson[];
};

/**
 * Describes the message raccoonai.DriverIncidentList.
 * Use `create(DriverIncidentListSchema)` to create a new message.
 */
export const DriverIncidentListSchema: GenMessage<DriverIncidentList, {jsonType: DriverIncidentListJson}> = /*@__PURE__*/
  messageDesc(file_driver_incident, 3);

/**
 * Incident reported by a driver from the driver app.
 * Distinct from the legacy TruckIncident (mechanic/sales reported):
 * a DriverIncident is always anchored to the driver's shift and may
 * additionally reference the active route and the current job.
 *
 * @generated from enum raccoonai.DriverIncidentType
 */
export enum DriverIncidentType {
  /**
   * @generated from enum value: DRIVER_INCIDENT_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Types available both on shift ("проблема на линии") and on a job.
   *
   * Поломка ТС
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_TRUCK_BREAKDOWN = 1;
   */
  TRUCK_BREAKDOWN = 1,

  /**
   * Произошло ДТП
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_TRAFFIC_ACCIDENT = 2;
   */
  TRAFFIC_ACCIDENT = 2,

  /**
   * Грузчикам нездоровится
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_LOADERS_UNWELL = 3;
   */
  LOADERS_UNWELL = 3,

  /**
   * Водителю нездоровится
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_DRIVER_UNWELL = 4;
   */
  DRIVER_UNWELL = 4,

  /**
   * Другое (с вами свяжется диспетчер)
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_OTHER = 5;
   */
  OTHER = 5,

  /**
   * Types available only on a job ("проблема на задаче").
   * Post-action: the jobs currently in progress are marked NOT_COMPLETED (no
   * copies are created — the dispatcher decides how to handle the missed
   * pickup) and the route moves on.
   *
   * КП запаркована машинами
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_PICKUP_LOCATION_BLOCKED = 6;
   */
  PICKUP_LOCATION_BLOCKED = 6,

  /**
   * Нет доступа к КП (закрыто)
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_PICKUP_LOCATION_NO_ACCESS = 7;
   */
  PICKUP_LOCATION_NO_ACCESS = 7,

  /**
   * Неподходящая техника
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_UNSUITABLE_EQUIPMENT = 8;
   */
  UNSUITABLE_EQUIPMENT = 8,

  /**
   * Notification only, the job continues as usual.
   *
   * Контейнер(ы) повреждены
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_CONTAINERS_DAMAGED = 9;
   */
  CONTAINERS_DAMAGED = 9,

  /**
   * The job's day ended without it being done: recorded by the system (the
   * midnight expiry) or by a dispatcher, never reported by a driver.
   *
   * Не успели (долг)
   *
   * @generated from enum value: DRIVER_INCIDENT_TYPE_EXPIRED = 10;
   */
  EXPIRED = 10,
}

/**
 * Incident reported by a driver from the driver app.
 * Distinct from the legacy TruckIncident (mechanic/sales reported):
 * a DriverIncident is always anchored to the driver's shift and may
 * additionally reference the active route and the current job.
 *
 * @generated from enum raccoonai.DriverIncidentType
 */
export type DriverIncidentTypeJson = "DRIVER_INCIDENT_TYPE_UNDEFINED" | "DRIVER_INCIDENT_TYPE_TRUCK_BREAKDOWN" | "DRIVER_INCIDENT_TYPE_TRAFFIC_ACCIDENT" | "DRIVER_INCIDENT_TYPE_LOADERS_UNWELL" | "DRIVER_INCIDENT_TYPE_DRIVER_UNWELL" | "DRIVER_INCIDENT_TYPE_OTHER" | "DRIVER_INCIDENT_TYPE_PICKUP_LOCATION_BLOCKED" | "DRIVER_INCIDENT_TYPE_PICKUP_LOCATION_NO_ACCESS" | "DRIVER_INCIDENT_TYPE_UNSUITABLE_EQUIPMENT" | "DRIVER_INCIDENT_TYPE_CONTAINERS_DAMAGED" | "DRIVER_INCIDENT_TYPE_EXPIRED";

/**
 * Describes the enum raccoonai.DriverIncidentType.
 */
export const DriverIncidentTypeSchema: GenEnum<DriverIncidentType, DriverIncidentTypeJson> = /*@__PURE__*/
  enumDesc(file_driver_incident, 0);

